import React, { useState } from "react";
import { Button, Modal, Form, Input, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import axios from "axios";
import { Error, Success } from "../../../commons/Messages/Messages";
import { renderTicketFields, toFormValues, fromFormValues } from "./ticketFields";

import { useTranslation } from "react-i18next";
const { Text } = Typography;

const UpdateTicketDrawer = ({ ticketdata, fields = [], ticketid, updateParent, onOpen }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    form.setFieldsValue({
      title: ticketdata.title,
      ticketValues: toFormValues(fields, ticketdata.ticketValues)
    });
    onOpen?.();
    setIsModalOpen(true);
  };

  const onFinish = async values => {
    try {
      setLoading(true);
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/tickets/update/${ticketid}`,
        {
          title: values.title,
          // Keep values of columns that were removed from the group since.
          ticketValues: {
            ...(ticketdata.ticketValues || {}),
            ...fromFormValues(fields, values.ticketValues)
          }
        },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      Success(t(res.data.successMessage || "Ticket updated successfully"));
      updateParent?.();
      setIsModalOpen(false);
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="text" block icon={<EditOutlined />} onClick={showModal}>
        {t("Update")}
      </Button>

      <Modal
        title={
          <div className="tkt-modal-title">
            <span>{t("Update Ticket")}</span>
            <span className="tkt-modal-subtitle">{t("Modify ticket specifications.")}</span>
          </div>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
        confirmLoading={loading}
        okText={t("Save")}
        cancelText={t("Cancel")}
        width={480}
        centered
        forceRender
        rootClassName="tkt-modal"
      >
        <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
          <Form.Item
            name="title"
            label={<Text strong>{t("Subject")}</Text>}
            rules={[{ required: true, whitespace: true, message: t("Required") }]}
          >
            <Input size="large" placeholder={t("Ticket Title")} />
          </Form.Item>

          {fields.length > 0 && (
            <div className="tkt-modal-section">
              <span className="tkt-modal-section__title">{t("Group Specifications")}</span>
              {renderTicketFields(fields, t)}
            </div>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default UpdateTicketDrawer;
